import { saveKnockOffInformation } from '../../services/commercialService';
import { handleApiEnviroment } from '../../WebComponents/commonComponents/customUtils';

export const saveKnockOffData = async (
  leadGenerationContext,
  knockOffReason,
  vouchedJobId,
  usersToString
) => {
  const data = {};
  const getRequestSource = (context) => {
    let requestSource = '';
    if (context?.testWCFlow || context?.wcFlow) {
      requestSource = context?.requestSource || 'OMB';
    }
    return requestSource;
  };
  const getDevicePlatform = (context) => {
    let devicePlatform = '';
    if ((context?.testWCFlow || context?.wcFlow) && context?.isMobileApp) {
      devicePlatform = 'D1 - Mobile';
    } else if ((context?.testWCFlow || context?.wcFlow) && !context?.isMobileApp) {
      devicePlatform = 'D1 - Web';
    }
    return devicePlatform;
  };
  let response = null;
  data.applicationId = leadGenerationContext.applicationId;
  data.applicantId = leadGenerationContext.applicantId;
  data.language = leadGenerationContext.language;
  data.location = leadGenerationContext.location;
  data.utmCampaign = leadGenerationContext.utmCampaign;
  data.utmMedium = leadGenerationContext.utmMedium;
  data.utmContent = leadGenerationContext.utmContent;
  data.utmTerm = leadGenerationContext.utmTerm;
  data.utmSource = leadGenerationContext.utmSource;
  data.knockOffReason = knockOffReason;
  data.vouchedJobId = vouchedJobId;
  data.usersToString = usersToString;
  data.requestSource = getRequestSource(leadGenerationContext);
  data.devicePlatform = getDevicePlatform(leadGenerationContext);
  // add arg allData data.allreason = allData;
  response = await saveKnockOffInformation(data, leadGenerationContext.accessToken, {
    isWCFlow: leadGenerationContext?.wcFlow,
    env: handleApiEnviroment(leadGenerationContext?.environment),
  });
  return response;
};
